import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "../../../hooks/useAuth";
import { createLogger } from '../../../utils/logger';
import { getDefaultPanelPath } from "../../../utils/panel-access";

const logger = createLogger('auth');

export default function RequireAuth({ allowedRoles }: any) {
  const { auth }: any = useAuth();
  const { roles }: any = useAuth();
  const location = useLocation();
  logger.debug('auth check', { allowedRoles, roles })
  
  const isAllowed = auth && roles?.some((role: any) => allowedRoles?.includes(role));
  
  if (isAllowed) {
    return <Outlet />
  }

  if (auth) {
    return <Navigate to={getDefaultPanelPath(roles)} replace />
  }

  return <Navigate to="/auth" state={{ from: location }} replace />
}
